export default __webpack_public_path__ + "static/media/after@2x.327cbdb5.png";